<div (click)="sortData(fieldName)" class="uk-text-nowrap pointer">
  <ng-container>{{ headerName }}</ng-container>

  <ng-container *ngIf="(state | async).params.order_by === '-' + fieldName; else ascending">
    <fa-icon class="active chevron" icon="chevron-up"></fa-icon>
  </ng-container>

  <ng-template #ascending>
    <fa-icon class="chevron" icon="chevron-down" [ngClass]="{ active: (state | async).params.order_by === fieldName }"> </fa-icon>
  </ng-template>
</div>
